module.exports = __webpack_public_path__ + "static/media/cancel.c86e6d50.png";